<template>
  <div>
    <div
      v-for="item in collection"
      :key="`item-${item.Id}`"
      class="product-item html2pdf__page-break"
    >
      <div class="main-image">
        <img v-if="item.ImagePath" :src="item.ImagePath" />
        <img v-else src="/img/No_Picture.png" />
      </div>

      <div class="bg-scancom">
        <div class="section-name">
          <h4 class="product-name">
            {{ item.ProductName }}
          </h4>
          <p v-if="item.ShortDescription">
            {{ item.ShortDescription }}
          </p>
        </div>

        <div v-if="item.MaterialConfigs" class="materials row">
          <div
            v-for="(material, i) in item.MaterialConfigs"
            :key="`material-${i}`"
            class="material-item col-6"
          >
            <!-- <div v-if="material.Code == 'NONE'" class="no-image"></div> -->
            <img
              :src="`${
                $http.defaults.baseURL
              }/Document/download/Materials/${material.Code.replace(
                '/',
                '-'
              )}.jpg`"
            />
            <p class="name">
              {{ material.Type }} <br />
              {{ material.Name }} <br />
              {{ material.Code }}
            </p>
          </div>
        </div>

        <div class="product-details">
          <table>
            <tbody>
              <tr>
                <td class="label">Drawing Code.</td>
                <td class="value">
                  {{ item.DrawingCode }}
                </td>
                <td class="label">Packing</td>
                <td class="value">
                  {{ item.Packing }}
                </td>
              </tr>
              <tr>
                <td class="label">
                  Loading(pcs) <br />
                  <span class="fw-normal">20/40/40'HC</span>
                </td>
                <td class="value">
                  {{ item.LoadingInfo }}
                </td>
                <td class="label">
                  Open dimension <br />
                  <span class="fw-normal">(L/DxWxH)(cm)</span>
                </td>
                <td class="value">
                  {{ item.OpenDimension }}
                </td>
              </tr>
              <tr>
                <template v-if="item.Volume">
                  <td class="label">Volume</td>
                  <td class="value">{{ $func.addCommas(item.Volume) }}</td>
                </template>

                <template v-if="item.Price">
                  <td class="label">FOB/Unit</td>
                  <td class="value">
                    ${{ parseFloat(item.Price).toFixed(2) }}
                  </td>
                </template>
              </tr>
            </tbody>
          </table>

          <div v-if="storeCart.Note" class="mt-2 text-italic">
            * Note: {{ storeCart.Note }}
          </div>
        </div>
      </div>

      <div class="page-title">
        <div class="logo">
          <img src="@/assets/images/logo.png" alt="" />
        </div>

        <div class="title">
          <p class="main">
            {{
              storeCart && storeCart.Name != "Unnamed Collection"
                ? storeCart.Name
                : "Star Product Program"
            }}
          </p>
          <p class="sub">Designed and Developed by ScanCom</p>
        </div>
        <!-- <img src="/img/logo.jpg" alt="" /> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["collection", "storeCart"],
};
</script>

<style lang="scss" scoped>
.product-item {
  background-color: #fff;
  position: relative;
  width: 800px;
  height: 1120px;
  // font-family: "Myriad Pro", Arial, sans-serif;
  text-align: left;
  padding: 1rem 4rem 4rem 4rem;
  color: #0e273b;

  .main-image {
    img {
      max-width: 100%;
    }
  }

  .product-name {
    font-size: 13.5pt;
    font-weight: bold;
  }

  .section-name {
    margin-bottom: 2rem;
    text-align: center;
  }

  .product-details {
    position: relative;
    font-size: 10pt;

    .label {
      font-weight: bold;
      width: 150px;
    }

    .value {
      min-width: 150px;
    }

    table {
      width: 100%;
      border: 1px solid #0e273b;

      td {
        border: 1px solid #0e273b;
        padding: 0.5rem;
      }
    }
  }

  .materials {
    position: relative;
    margin-bottom: 1.5rem;

    .material-item {
      margin-bottom: 1.5rem;

      img,
      .no-image {
        width: 60px;
        height: 60px;
        float: left;
      }

      .no-image {
        border: 1px solid #0e273b;
        display: inline-block;
      }

      .name {
        display: inline-block;
        margin: 0 1rem;
        font-weight: 500;
        font-size: 10pt;
      }
    }
  }

  .logo {
    text-align: left;
    float: left;
    img {
      height: 60px;
    }
  }

  .page-title {
    border-top: 1px solid #0e273b;
    position: absolute;
    width: calc(100% - 6rem);
    text-align: right;
    bottom: 0.5rem;
    z-index: 1;

    .title {
      display: inline-block;
      margin: 0.5rem 0;

      .main {
        margin-bottom: 0;
        font-weight: bold;
        font-size: 11pt;
        text-transform: uppercase;
      }
      .sub {
        font-size: 9pt;
      }
    }
    // img {
    //   width: 45px;
    //   height: 45px;
    //   margin: 0.5rem;
    //   float: right;
    // }
  }

  .bg-scancom {
    position: relative;
  }

  .bg-scancom::before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: calc(50% - 150px);
    background-image: url("/img/logo.jpg");
    background-size: 300px 300px;
    // background-position: 30px 30px;
    background-repeat: no-repeat;
    opacity: 0.1;
    height: calc(100vh);
  }
}
</style>
